
;
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreLibModule, CoreLibService } from 'core-lib';
import { GroupPickerModule } from 'core-ui';
import { MessageService } from 'primeng/api';
import { AuthInterceptor } from '../auth.interceptor';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppointmentModuleLibModule } from './appointment-module-lib.module';
import { providePrimeNG } from 'primeng/config';
import {getAppackTheme} from '../theme';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeES from '@angular/common/locales/es';
import localeFR from '@angular/common/locales/fr';
registerLocaleData(localeES);
registerLocaleData(localeDe);
registerLocaleData(localeFR);

export function localeFactory(): string {
    const supported = ['en', 'de', 'fr', 'es'];
    const userLocale = navigator.language;

    // Check if starts with one of the supported locales
    const match = supported.find(loc => userLocale.startsWith(loc));
    return match ?? 'en'; // fallback to English
}

@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [CoreLibModule.forRoot(environment),
        BrowserModule,
        AppRoutingModule,
        AppointmentModuleLibModule,
        BrowserAnimationsModule,
        GroupPickerModule], providers: [
        { provide: LOCALE_ID, useFactory: localeFactory },
        providePrimeNG({
            theme: {
                preset: getAppackTheme(), options: {
                    darkModeSelector: '.app-dark',
                }
            },
            translation:
                {
                    dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                    dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                    dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                    monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'July', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                    today: 'heute',
                    clear: 'Zurücksetzen'
                }
        }),
        {
            provide: 'language',
            useFactory: () => {
                const userLang = window.navigator.language.split('-')[0];
                return userLang;
            }
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
            deps: [CoreLibService]
        }, MessageService, provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule { }
